import React, { useEffect, useState } from 'react'
import { useFindMenu, useTrans } from '@next-nx/hooks'
import { WContainer, Breadcrumbs, MainTitle, Button, Dropdown } from '@next-nx/shared-ui/atoms'
import { ImageTextBanner, Page } from '@next-nx/shared-ui/organisms'
import { ArticoloCard } from '@next-nx/shared-ui/molecules'
import styles from './MagazineListingTemplate.module.sass'
import { NEWS_LISTING_ITEMS_PER_PAGE } from '@next-nx/utils/settings'
import { useAllMagazineLazyQuery } from '@next-nx/shared-graphql/unipolrental'
import FiltersTriangle from '../../atoms/Icons/FiltersTriangle'

interface Props {
  className?: string
  pagina: any
  allMagazine: any
}

const MagazineListingTemplate = (props: Props) => {
  const { className = '', pagina = {}, allMagazine = undefined } = props

  const MagazineMenu = useFindMenu('pagina-magazine')
  const BoxMagazine = useFindMenu('box-magazine', MagazineMenu)

  const t = useTrans()

  const ordinamenti = [
    { value: 'data_pubblicazione', label: t('Meno recente') },
    { value: '-data_pubblicazione', label: t('Più recente') },
  ]

  const [ordinamentoSelected, setOrdinamentoSelected] = useState(ordinamenti[1])

  const [magazine, setMagazine] = useState(allMagazine)

  const [getAllMagazine, { data }] = useAllMagazineLazyQuery()

  const handleOrdinamento = (v) => {
    const newOrdinamentoSelected = ordinamenti.find((o) => o.value === v) || ordinamentoSelected
    setOrdinamentoSelected(newOrdinamentoSelected)

    getAllMagazine({
      variables: {
        orderBy: newOrdinamentoSelected.value,
      },
    })
  }
  const [numItems, setNumItems] = useState(NEWS_LISTING_ITEMS_PER_PAGE)

  useEffect(() => {
    if (data) {
      setMagazine(data)
    }
  }, [data])

  const magazineToShow = magazine?.allMagazine.edges.filter((n, i) => i < numItems)

  return magazine && magazine.allMagazine ? (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={pagina?.titolo} className={styles.title} />
        <div className={styles.list}>
          <div className={styles.articoliTotali}>
            {magazine.allMagazine.edges.length} {t('articoli totali')}
          </div>
          <Dropdown
            icon={<FiltersTriangle />}
            label={t('Ordina per: {0}', [ordinamentoSelected.label])}
            options={ordinamenti}
            value={ordinamentoSelected.value}
            setValue={(v) => handleOrdinamento(v)}
            highlightOnCompiled={false}
            dropdownVariant="arrow"
            className={styles.listOrder}
          />
        </div>
        <div className={styles.listing}>
          {magazine.allMagazine.edges
            .filter((n, i) => i < numItems)
            .map(
              (n) =>
                n?.node && (
                  <div className={styles.item} key={n.node.pk}>
                    <ArticoloCard news={n.node} withDataPubblicazione />
                  </div>
                )
            )}
        </div>
        <div className={styles.ordinamenti}>
          <p>
            {t('Hai visualizzato {0} articoli di {1}', [
              magazineToShow.length,
              magazine.allMagazine.edges.length,
            ])}
          </p>

          {numItems < magazine.allMagazine.edges.length && (
            <Button
              onClick={() => setNumItems(numItems + NEWS_LISTING_ITEMS_PER_PAGE)}
              label={t('Carica altri')}
              color={'blue'}
            />
          )}
        </div>
      </WContainer>
      {!!BoxMagazine && (
        <ImageTextBanner className={styles.BoxMagazine} item={BoxMagazine}></ImageTextBanner>
      )}
      <WContainer></WContainer>
    </Page>
  ) : (
    <></>
  )
}

export default MagazineListingTemplate
